import * as React from 'react';
import { Slug } from '@fnv-core/utils';
import { FormControlProps } from '../interfaces/FormControlProps';
import { FormControlHelpers } from './helpers/FormControlHelpers';
import { ComponentStoreHelpers } from './helpers/ComponentStoreHelpers';
import { FormLabelHelpers } from './helpers/FormLabelHelpers';
import { FormStylingHelpers } from './helpers/FormStylingHelpers';
import { AjaxCallHelpers } from './helpers/AjaxCallHelpers';
import ReactHtmlParser from 'react-html-parser';
import { LabelAndPopover } from './components/label-and-popover';
import { PropertyHelpers } from '../helpers/PropertyHelpers';
import { FormFieldStateHelpers } from './helpers/FormFieldStateHelpers';

export interface CheckboxState {
    dataSourceCounter: number;
    timer: any;
    label: string;
    hasFocus: boolean;
}

class Checkbox extends React.Component<FormControlProps, CheckboxState> {
    constructor(props: FormControlProps) {
        super(props);
        
        this.state = {
            dataSourceCounter: 0,
            timer: undefined,
            label: undefined,
            hasFocus: false
        };

    }

    changeValidationError = () => {
        if (this.props.formFieldDefinition.validation &&
            this.props.formFieldDefinition.validation.required) {
            if (this.props.formConfig.algemenevoorwaardenLinkTekst) {
                const errorLabel = this.props.formFieldDefinition.validation.required.error.replace('[ALGEMENEVOORWAARDEN]', 
                    this.props.formConfig.algemenevoorwaardenLinkTekst);
                this.props.formFieldDefinition.validation.required.error = errorLabel;
            }            
        }
    }

    componentDidMount() {
        this.changeValidationError();

        if (ComponentStoreHelpers.hasDatasource(this)) {
            ComponentStoreHelpers.getData(this).then((data) => 
            {
                if(data && !this.unmounted) {
                    this.setState({label: (data as any).ShortText});
                }
            });
        }
    }

    unmounted : boolean = false;
    componentWillUnmount() {
        this.unmounted = true;
    }

    onInputFocus = (event) => {                
        this.setState({hasFocus : true});
    }

    onInputBlur = (event) => {
        if (event.persist) {
            event.persist();
        }
        this.setState({hasFocus : false}, () => {
            this.props.field.onBlur(event);
        });
    }

    render() {
        let label: string = this.state.label ? this.state.label : this.props.formFieldDefinition.optionyes;
        let linkAlgemeneVoorwaarden = null;
        let self = this;
        let dontRenderLabelAboveInput = false;

        const fieldProperties = {
            ...FormControlHelpers.inputProperties(this),
        };

        let isRequired = this.props.formFieldDefinition.validation['required'] !== undefined;

        if (this.props.formFieldDefinition.optionyes.indexOf('[ALGEMENEVOORWAARDEN]') >= 0) {
            label = label.replace('[ALGEMENEVOORWAARDEN]', '');
            dontRenderLabelAboveInput = true;
            linkAlgemeneVoorwaarden = (
                <>
                    <a
                        className="form__algemene-voorwaarden-link"
                        href={this.props.formConfig.algemenevoorwaarden}
                        target="_blank"
                    >
                        {ReactHtmlParser(this.props.formConfig.algemenevoorwaardenLinkTekst)}
                    </a>
                    <span>{isRequired ? " *" : ""}</span>
                </>
            );
        } else {
            linkAlgemeneVoorwaarden = <span>{isRequired ? " *" : ""}</span>;
        }
        
        return (
            <div className={'form-group form-checkbox-group ' + this.props.visibilityClass + ' ' + Slug.fromString(this.props.formFieldDefinition.name) + "-checkbox-form-group"}>
               {((!dontRenderLabelAboveInput && 
                label !== this.props.formFieldDefinition.label && 
                this.props.formFieldDefinition.label != '') || 
                (!!this.props.formFieldDefinition.hasPopover)) ? (
                    <LabelAndPopover 
                        className="form__checkbox"
                        fieldId={PropertyHelpers.getFieldID(this.props)} 
                        label={FormLabelHelpers.getFieldLabel(this)}
                        explanation={this.props.formFieldDefinition.explanation}
                        hasPopover={this.props.formFieldDefinition.hasPopover}                    
                    ></LabelAndPopover>
                ) : null}
                <div className="custom-control custom-checkbox">
                    <input
                        {...fieldProperties}
                        checked={(this.props.field.value || "").toString().toLowerCase() === "true"}
                        className={FormStylingHelpers.getCheckboxStyle(this) + " " +
                        (!!this.state.hasFocus ? "has-focus" : "")}
                        type="checkbox"
                        disabled={!!this.props.formFieldDefinition.readOnly}
                        value={this.props.formFieldDefinition.valueyes}
                        id={this.props.formFieldDefinition.name + "-" + this.props.formController.props.formName}
                        onFocus={this.onInputFocus}
                        onBlur={this.onInputBlur}
                    />
                    <label
                        htmlFor={this.props.formFieldDefinition.name + "-" + this.props.formController.props.formName}
                        className="custom-control-label"
                    >
                        {ReactHtmlParser(label)} {linkAlgemeneVoorwaarden}
                    </label>
                </div>
                {!this.state.hasFocus && FormControlHelpers.invalidFeedbackComponent(this)}
            </div>
        );
    }
}

export { Checkbox };
